/**
 * Registers a "beforeunload" listener that releases a held section lock when the
 * user closes the tab/browser, navigates away, or reloads the page.
 *
 * `shouldUnlock` is re-evaluated at unload time (not when this is called) so callers
 * can pass a closure over live state (e.g. "is a lock currently held").
 *
 * Returns a cleanup function that removes the listener; callers should invoke it on
 * unmount (or when the guarded state no longer holds a lock) to avoid leaking listeners
 * across component instances.
 */
const bindUnloadUnlock = (shouldUnlock: () => boolean, releaseLock: () => void) => {
  const handler = () => {
    if (!shouldUnlock()) return;
    releaseLock();
  };

  window.addEventListener("beforeunload", handler);

  return () => window.removeEventListener("beforeunload", handler);
};

export { bindUnloadUnlock };
